import {StepProps} from '../IAppModels'
import {useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {useAuth} from '../../../../../app/modules/auth'

const formatDate = (dateString: string) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  return date
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    .split('/')
    .join('-')
}

const Step4 = ({data, updateData}: StepProps) => {
  const navigate = useNavigate()
  const user = useAuth()
  const [previewData, setPreviewData] = useState<any>(null)

  useEffect(() => {
    const currentDate = new Date().toISOString().slice(0, 10)
    const previewPayload = {
      providerName: user.currentUser?.providerName,
      providerAddress: user.currentUser?.providerAddress,
      providerCity: user.currentUser?.providerCity,
      member: {
        memberName: data.appBasic?.memberData?.memberName,
        cardNumber: data.appBasic?.memberData?.cardNumber,
        dateOfBirth: data.appBasic?.memberData?.dateOfBirth,
        policyNumber: data.appBasic?.memberData?.policyNumber,
      },
      clientName: data.appBasic?.memberData?.clientName,
      phone: data.appBasic?.memberData?.phoneNumber,
      benefitDetail: data.appBasic?.benefitDetail,
    }
    setPreviewData(previewPayload)
  }, [data, user.currentUser])

  return (
    <>
      <div
        className='pb-5'
        data-kt-stepper-element='content'
        style={{
          height: 'calc(100vh - 450px)',
          overflow: 'auto',
          width: '100%',
          maxWidth: '100%',
          marginBottom: '20px',
        }}
      >
        <div className='w-100'>
          <div className='fv-row'>
            <div className='stepper-label mb-8'>
              <h3 className='stepper-title'>Tinjau dan Buat</h3>
              <div className='stepper-desc' style={{color: '#059BB6'}}>
                *
              </div>
            </div>

            {/* Document Preview */}
            <div
              className='preview-container'
              style={{
                border: '1px solid #E1E2EA',
                borderRadius: '8px',
                padding: '30px',
                marginBottom: '20px',
                backgroundColor: 'white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                width: '100%',
                maxWidth: '1200px',
                margin: '0 auto',
              }}
            >
              {previewData && (
                <div
                  style={{
                    width: '100%',
                    margin: '0 auto',
                    padding: '0 35px',
                    maxWidth: '1300px',
                  }}
                >
                  {/* Header with Logo and Provider Info */}
                  <div
                    style={{
                      marginBottom: '20px',
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div style={{flex: '0 0 auto'}}>
                      {/* <img src='./hms.png' alt='HealthMetrics' style={{height: '40px'}} /> */}
                      <img
                        src='./afi.png'
                        alt='AFI Logo'
                        style={{height: '70px', width: '70px', borderRadius: '5px'}}
                      />
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                        textAlign: 'right',
                      }}
                    >
                      <div style={{fontWeight: '500'}}>{user.currentUser?.providerName}</div>
                      <div style={{color: '#6C757D', fontSize: '0.9em'}}>
                        {user.currentUser?.providerAddress}
                      </div>
                      <div style={{color: '#6C757D', fontSize: '0.9em'}}>
                        {user.currentUser?.providerCity}
                      </div>
                    </div>
                  </div>

                  {/* Patient Info in Two Columns - Made more responsive */}
                  <div
                    style={{
                      display: 'flex',
                      gap: '40px',
                      marginBottom: '20px',
                      width: '100%',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div style={{flex: 1}}>
                      <table style={{width: '100%', borderSpacing: '0 8px'}}>
                        <tbody>
                          <tr>
                            <td style={{width: '120px'}}>Nama Pasien</td>
                            <td style={{width: '10px'}}>:</td>
                            <td>{previewData.member.memberName}</td>
                          </tr>
                          <tr>
                            <td>Nomor Kartu</td>
                            <td>:</td>
                            <td>{previewData.member.cardNumber}</td>
                          </tr>
                          <tr>
                            <td>Tanggal Lahir</td>
                            <td>:</td>
                            <td>{formatDate(previewData.member.dateOfBirth)}</td>
                          </tr>
                          <tr>
                            <td>Nomor Polis</td>
                            <td>:</td>
                            <td>{data.appBasic?.memberData?.policyNo}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div style={{flex: 1}}>
                      <table style={{width: '100%', borderSpacing: '0 8px'}}>
                        <tbody>
                          <tr>
                            <td style={{width: '120px'}}>Masa Polis</td>
                            <td style={{width: '10px'}}>:</td>
                            <td>N/A</td>
                          </tr>
                          <tr>
                            <td>Klien</td>
                            <td>:</td>
                            <td>{data.appBasic?.memberData?.insurerName}</td>
                          </tr>
                          <tr>
                            <td>No. Telp. Pasien/ Pendaming</td>
                            <td>:</td>
                            <td>{data.appBasic?.phoneNumber}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Benefits Section */}
                  <div style={{marginTop: '30px'}}>
                    <h6
                      style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        marginBottom: '20px',
                      }}
                    >
                      Manfaat -{' '}
                      {data.appBasic?.benefitDetail?.benefitName === 'OUTPATIENT'
                        ? 'Pendaftaran Pasien Rawat Jalan'
                        : data.appBasic?.benefitDetail?.benefitName === 'INPATIENT'
                        ? 'Pendaftaran Pasien Rawat Inap'
                        : data.appBasic?.benefitDetail?.benefitName}
                    </h6>

                    <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                      {data.appBasic?.benefitDetail?.subBenefits?.map(
                        (benefit: any, index: number) => (
                          <div
                            key={index}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '8px 0',
                              borderBottom: '1px solid #E1E2EA',
                            }}
                          >
                            <span
                              style={{
                                color: '#059BB6',
                                marginRight: '8px',
                                fontSize: '16px',
                              }}
                            >
                              ✓
                            </span>
                            <span style={{color: '#4B4D63'}}>{benefit.subBenefitName}</span>
                          </div>
                        )
                      )}
                    </div>
                  </div>

                  {/* Ketentuan Section */}
                  <div style={{marginTop: '30px'}}>
                    <h6
                      style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        marginBottom: '15px',
                      }}
                    >
                      Ketentuan
                    </h6>
                    {/* <p style={{ color: '#4B4D63', fontSize: '16px' }}>
                      {data.appBasic?.benefitDetail?.condition}
                    </p> */}
                    <div
                      dangerouslySetInnerHTML={{__html: data.appBasic?.benefitDetail?.condition}}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {Step4}
